// @flow
// $FlowFixMe
import React from 'react';
import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';
import {subDays, isBefore, parse as parseDate} from 'date-fns';

import FlexibleDatesOptionIcon from './FlexibleDatesOptionIcon';

import './FlexibleDatesOption.less';

import type {
    FlexibleDatesOptionProps,
    FlexibleDatesOptionExtraProps
} from './FlexibleDates';
import FlexibleDatesOptionsPropertyCount from './FlexibleDatesOptionPropertyCount';

type Props = {
    type: 'add' | 'sub',
    resultCountDifferenceForNewDates: number | null
} & FlexibleDatesOptionProps &
    FlexibleDatesOptionExtraProps;

const LINGUA_KEYS = {
    OneWeekEarlier: 'flexibleDatesOneWeekEarlier',
    OneDayEarlier: 'flexibleDatesOneDayEarlier',
    OneDayLater: 'flexibleDatesOneDayLater',
    OneWeekLater: 'flexibleDatesOneWeekLater'
};

const getFlexibleDatesOptionsLabelTranslation = (id) => {
    return {
        OneWeekEarlier: LINGUA_KEYS.OneWeekEarlier,
        OneDayEarlier: LINGUA_KEYS.OneDayEarlier,
        OneDayLater: LINGUA_KEYS.OneDayLater,
        OneWeekLater: LINGUA_KEYS.OneWeekLater
    }[id];
};

export default function FlexibleDatesOption({
    type,
    id,
    label,
    startDate,
    endDate,
    days,
    onDateChange,
    loading,
    locale,
    resultCountDifferenceForNewDates
}: Props) {
    const actualStartDate = parseDate(startDate, 'yyyy-MM-dd', new Date());
    const actualEndDate = parseDate(endDate, 'yyyy-MM-dd', new Date());

    function changeDates() {
        onDateChange({
            startDate,
            endDate,
            eventlabel: label.toLowerCase()
        });
    }

    let sameDayUnavailable = false;

    if (type === 'sub') {
        if (isBefore(actualStartDate, subDays(new Date(Date.now()), 1))) {
            sameDayUnavailable = true;
        }
    }

    const {format} = new Intl.DateTimeFormat(locale, {
        day: 'numeric',
        month: 'short'
    });

    const flexibleDatesOptionMarkup = (unavailable) => (
        <button
            type="button"
            className={classNames('FlexibleDatesOption', {
                'FlexibleDatesOption--right': type === 'add',
                'FlexibleDatesOption--unavailable': unavailable
            })}
            onClick={changeDates}
            disabled={!!loading || unavailable}
        >
            <FlexibleDatesOptionIcon type={type} days={days} />
            <span className="FlexibleDatesOption__Text">
                <span className="FlexibleDatesOption__Label">
                    <FormattedMessage
                        id={getFlexibleDatesOptionsLabelTranslation(id)}
                        defaultMessage={label}
                    />
                </span>
                <span className="FlexibleDatesOption__Dates">
                    {unavailable ? (
                        <FormattedMessage
                            id="flexibleDatesUnavailable"
                            defaultMessage="Unavailable"
                        />
                    ) : (
                        `${format(actualStartDate)} – ${format(actualEndDate)}`
                    )}
                </span>
                {!unavailable && (
                    <FlexibleDatesOptionsPropertyCount
                        loading={loading}
                        resultCountDifferenceForNewDates={
                            resultCountDifferenceForNewDates
                        }
                    />
                )}
            </span>
        </button>
    );
    return flexibleDatesOptionMarkup(sameDayUnavailable);
}
